import { render, staticRenderFns } from "./district-search.vue?vue&type=template&id=19148ea8&"
import script from "./district-search.vue?vue&type=script&lang=js&"
export * from "./district-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports